/**
 * Payme Payment Integration Utilities
 * 
 * Note: Payme URL generation is now handled server-side for security.
 * The Kassa ID is no longer exposed in the frontend.
 */

/**
 * Check if Payme is configured
 * Note: This now checks if the backend function is available,
 * not if frontend has Kassa ID (which it shouldn't)
 */
export function isPaymeConfigured(): boolean {
  // Payme is configured if Supabase URL is available
  // The actual Kassa ID check happens server-side
  return !!import.meta.env.VITE_SUPABASE_URL;
}

